<template>
  <div>
    <table class="table mb-0">
      <tbody v-if="!loading">
        <tr>
          <td colspan="2">Total de situações no filtro atual</td>
          <td class="text-right">
            {{ status.total > 0 ? status.total : '-' }}
          </td>
        </tr>
        <tr>
          <td>DELEGADO</td>
          <td>{{ status.delegated > 0 ? status.delegated : '-' }}</td>
          <td class="text-right">
            {{ calc_percentage(status.delegated, status.total) }}%
          </td>
        </tr>
        <tr>
          <td>PROGRAMADO</td>
          <td>{{ status.scheduled > 0 ? status.scheduled : '-' }}</td>
          <td class="text-right">
            {{ calc_percentage(status.scheduled, status.total) }}%
          </td>
        </tr>
        <tr>
          <td>ORÇADO</td>
          <td>{{ status.budgeted > 0 ? status.budgeted : '-' }}</td>
          <td class="text-right">
            {{ calc_percentage(status.budgeted, status.total) }}%
          </td>
        </tr>
        <tr>
          <td>PROJETADO</td>
          <td>{{ status.projected > 0 ? status.projected : '-' }}</td>
          <td class="text-right">
            {{ calc_percentage(status.projected, status.total) }}%
          </td>
        </tr>
        <tr>
          <td>EM ADEQUAÇÃO</td>
          <td>{{ status.in_adequacy > 0 ? status.in_adequacy : '-' }}</td>
          <td class="text-right">
            {{ calc_percentage(status.in_adequacy, status.total) }}%
          </td>
        </tr>
        <tr>
          <td>CONCLUÍDO</td>
          <td>{{ status.concluded > 0 ? status.concluded : '-' }}</td>
          <td class="text-right">
            {{ calc_percentage(status.concluded, status.total) }}%
          </td>
        </tr>
        <tr>
          <td>HOMOLOGADO</td>
          <td>{{ status.homologated > 0 ? status.homologated : '-' }}</td>
          <td class="text-right">
            {{ calc_percentage(status.homologated, status.total) }}%
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    setup() {
      const calc_percentage = (number, of_number) => {
        return of_number > 0
          ? parseFloat((number / of_number) * 100).toFixed(2)
          : 0
      }

      return {
        calc_percentage,
      }
    },
    props: {
      loading: Boolean,
      status: {
        type: Object,
        required: false,
        default: () => {
          return {
            total: 0,
            delegated: 0,
            scheduled: 0,
            budgeted: 0,
            projected: 0,
            in_adequacy: 0,
            concluded: 0,
            homologated: 0,
          }
        },
      },
    },
  }
</script>
